import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"
import { useEffect, useState } from "react"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <div className="h-9 w-9" />
  }

  return (
    <button
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className="flex items-center justify-center h-9 w-9 rounded border border-border bg-background hover:bg-muted/50 transition-colors"
      title="Toggle theme"
    >
      {theme === 'dark' ? (
        <Moon className="h-[1.2rem] w-[1.2rem] text-electric-blue" />
      ) : (
        <Sun className="h-[1.2rem] w-[1.2rem] text-electric-blue" />
      )}
      <span className="sr-only">Toggle theme</span>
    </button>
  )
}
